import axios from 'axios';
import React, { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { ClearMiniBetStore, DoMiniBetting, SetBetData, SetBetType } from '../../common/actions/miniAction';
import { isEmpty, no_comma, ResizePowerballFrame, toastr } from '../../common/cores';
import { api_url } from '../../common/cores/keys';
import { socket } from '../../common/cores/socket';
import MinigameVideo from './MinigameVideo';


const powerBalls = [
    {
        name: 'EOS 파워볼 1분',
        value: 1
    },
    {
        name: 'EOS 파워볼 2분',
        value: 2
    },
    {
        name: 'EOS 파워볼 3분',
        value: 3
    },
    {
        name: 'EOS 파워볼 4분',
        value: 4
    },
    {
        name: 'EOS 파워볼 5분',
        value: 5
    },
]
const MinigameCenter = (props) => {

    const {  rates, ballPrice, gameGrps, money } = props;


    const [beted, setBeted] = useState({});

    const onClickBetButton = (data) => {
        let param = {
            odd_key: data.odd_key,
            rate: data.price,
            name: data.name
        }
        setBeted(param);
        props.SetBetData(param);
    }
    const onChange = (e) => {
      const { value } = e.target; // 우선 e.target 에서 name 과 value 를 추출
      console.log(isNaN(Number(no_comma(value))))
      if(!isNaN(Number(no_comma(value))))
        props.setMoney(Number(no_comma(value)));
      else props.setMoney(0);
    };

    const pulusMoney = () => {
        props.setMoney( money + 1000 )
    }

    const minusMoney = () => {
        if((money - 1000) > 0) 
            props.setMoney( money - 1000 ); 
        else props.setMoney(0)
    }

    useEffect(()=>{
        ResizePowerballFrame();
    },[])

        const clear = () => {
            setBeted({});
            props.ClearMiniBetStore();
            props.setMoney(0);
        }

        const onBetting = () => {
            props.onBetting();
        }

        const getButton = (data) => {
            return (
                    <td width="10%" key={data.index} onClick={() => onClickBetButton(data)}>
                        <a >
                            <span className={`mini_power_btn${data.index + 1} ${beted.odd_key === data.odd_key && 'active'}`}>
                                <span className="mini_power_font">{data.name}</span>
                                <br />
                                {data.price}
                            </span>
                        </a>
                    </td>
                )
        }
        let cnt = 0;

        // ballPrice, gameGrps
    return gameGrps.map((gameGrp, index) => (
                <div className={`mini_power_big_wrap ${gameGrp.iswide ? "w100" : "w50"}`} key={index}>
                    <table width="100%" border="0" align="center" cellPadding="0" cellSpacing="0">
                        <tbody>
                            <tr>
                                <td width="100%" align="center"><span className="mini_power_title">{gameGrp.label}</span></td>
                            </tr>
                        </tbody>
                    </table>
                    <table width="100%" border="0" align="center" cellPadding="0" cellSpacing="1" >
                        <tbody>
                            <tr>
                                {
                                    gameGrp.buttons.map((button, index) => {
                                        return getButton({...button, price: Number(ballPrice[cnt]), index: index })
                                    })
                                }
                            </tr>
                        </tbody>
                    </table>
                </div>
    ))
};

const mapStateToProps = state => ({
    betted: state.mini.data,
  rates: state.mini.rates,
  state: state.mini.state,
  user: state.user
});

export default connect(mapStateToProps, { SetBetData, DoMiniBetting, SetBetType, ClearMiniBetStore })(MinigameCenter);


// WEBPACK FOOTER //
// ./src/components/Minigame/EOSPanel.js